import { render, staticRenderFns } from "./LoanApplications.vue?vue&type=template&id=ca6f356a&scoped=true&"
import script from "./LoanApplications.vue?vue&type=script&lang=ts&"
export * from "./LoanApplications.vue?vue&type=script&lang=ts&"
import style0 from "./LoanApplications.vue?vue&type=style&index=0&id=ca6f356a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6f356a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSpacer})
